import React from 'react'
import { Row, Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'
import ContactForm from './ContactForm'
import Container from './Container'
import Heading, { Buttons, Copy, HeadingColumnInner, StyledHeading } from './Heading'
import Section from './Section'
import { BodyCopy, H1 } from './Typography'
import media from 'css-in-js-media'
import { StyledButton } from './ButtonStyled'
import { StyledTitle } from './Title'
import { Variables } from '../styles/Variables'

const ContactSection = styled(Section)`
    background-color: ${Variables.color.pazola};
    margin: 0;

    padding-top: 80px;
    padding-bottom: 80px;

    ${media('<desktop')} {
        padding-top: 40px;
        padding-bottom: 40px;
    }

    ${Col} {
        ${media('<desktop')} {
            width: 100%;
        }
    }
`

const AddressBlock = styled.div`
    margin-bottom: 40px;

    ${StyledHeading} {
        background-color: ${Variables.color.pazola};
    }

    ${BodyCopy} {
        text-align: left;
        margin: 10px 0;
        line-height: 160%;
        color: ${Variables.color.white};
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        ${media('<desktop')} {
            font-size: 18px;
            line-height: 22px;
        }
    }
    ${HeadingColumnInner} {
        margin-left: 0;
    }
    ${StyledTitle} {
        color: ${Variables.color.white};
        text-align: left;
        font-family: ${Variables.font.title};
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 30px;
        h2 {
            color: ${Variables.color.white};
            text-align: left;
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 400;
            font-size: 24px;
            line-height: 30px;
        }
    }

    ${Copy} {
        margin: 0;
    }

    ${StyledButton} {
        background-color: ${Variables.color.pazola};
        color: ${Variables.color.white};
        border-color: ${Variables.color.white};
        ${media('<desktop')} {
            max-width: 263px;
        }
        &::before {
            border-color: ${Variables.color.white};
        }
        &:hover {
            background-color: ${Variables.color.pazolaGold};
            color: ${Variables.color.white};
            border-color: ${Variables.color.pazolaGold};
        }
    }

    ${Buttons} {
        text-align: left;
    }
`

const ContactformWrap = styled.div`
    ${media('>=desktop')} {
        padding-left: 36px;
        padding-right: 11%;
    }

    ${StyledButton} {
        background-color: ${Variables.color.pazola};
        color: ${Variables.color.white};
        ${media('>=desktop')} {
            max-width: 308px;
        }

        &:hover {
            background-color: ${Variables.color.pazolaGold};
            &::before {
                border-color: ${Variables.color.white} ;
            }
        }
    }
`

const StyledH1 = styled(H1)`
    padding: 77px 0 100px 0;
    font-family: ${Variables.font.title};
    color: ${Variables.color.white};
    font-style: normal;
    font-weight: 300;
    font-size: 32px;
    line-height: 37px;
    ${media('<desktop')} {
        padding: 146px 0 53px 0;
        font-size: 24px;
        line-height: 30px;
    }
`

const StyledCol = styled(Col)`
    padding: 0;
`

const ContactFormSection: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <>
            {data && (
                <ContactSection>
                    <Container>
                        <StyledCol md={8}>
                            <StyledH1>{data?.title}</StyledH1>
                        </StyledCol>
                        <Row>
                            <Col md={3}>
                                {data.headings &&
                                    data.headings.map((d, i) => {
                                        return (
                                            <AddressBlock key={i}>
                                                <Heading data={d} noMargin />
                                            </AddressBlock>
                                        )
                                    })}
                            </Col>
                            <Col md={9}>
                                <ContactformWrap>
                                    <ContactForm layout="2" darktheme />
                                </ContactformWrap>
                            </Col>
                        </Row>
                    </Container>
                </ContactSection>
            )}
        </>
    )
}

export default ContactFormSection
